import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-113b3b44")
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "tab-title" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "远景图", -1)
const _hoisted_4 = {
  key: 0,
  class: "img-box"
}
const _hoisted_5 = { class: "tab-title" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "近景图", -1)
const _hoisted_7 = {
  key: 0,
  class: "img-box"
}
const _hoisted_8 = { class: "tab-title" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "细节图", -1)
const _hoisted_10 = {
  key: 0,
  class: "img-box"
}
const _hoisted_11 = { class: "tab-title" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "视频", -1)
const _hoisted_13 = {
  key: 0,
  class: "img-box"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "video-time" }
const _hoisted_16 = { class: "tab-title" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "VR全景", -1)
const _hoisted_18 = {
  key: 0,
  class: "img-box"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_van_image_preview = _resolveComponent("van-image-preview")!
  const _component_preview_video = _resolveComponent("preview-video")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.flag)
      ? (_openBlock(), _createBlock(_component_van_tabs, {
          key: 0,
          active: _ctx.active,
          "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => (_ctx.active = $event)),
          color: `#61E4A9`,
          ref: "tabs"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_tab, null, {
              title: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _hoisted_3,
                  _createElementVNode("span", null, "(" + _toDisplayString(_ctx.initInfo.img.length) + ")", 1)
                ])
              ]),
              default: _withCtx(() => [
                (_ctx.initInfo.img.length != 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.initInfo.img, (item) => {
                        return (_openBlock(), _createBlock(_component_van_image, {
                          key: item.id,
                          fit: "cover",
                          width: "6.375rem",
                          height: "6.375rem",
                          src: item.url,
                          onClick: ($event: any) => (_ctx.preImage(1, item.id))
                        }, null, 8, ["src", "onClick"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_van_tab, null, {
              title: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("span", null, "(" + _toDisplayString(_ctx.initInfo.shotImg.length) + ")", 1)
                ])
              ]),
              default: _withCtx(() => [
                (_ctx.initInfo.shotImg.length != 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.initInfo.shotImg, (item) => {
                        return (_openBlock(), _createBlock(_component_van_image, {
                          key: item.id,
                          fit: "cover",
                          width: "6.375rem",
                          height: "6.375rem",
                          src: item.url,
                          onClick: ($event: any) => (_ctx.preImage(2, item.id))
                        }, null, 8, ["src", "onClick"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_van_tab, null, {
              title: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("span", null, "(" + _toDisplayString(_ctx.initInfo.detailImg.length) + ")", 1)
                ])
              ]),
              default: _withCtx(() => [
                (_ctx.initInfo.detailImg.length != 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.initInfo.detailImg, (item) => {
                        return (_openBlock(), _createBlock(_component_van_image, {
                          key: item.id,
                          fit: "cover",
                          width: "6.375rem",
                          height: "6.375rem",
                          src: item.url,
                          onClick: ($event: any) => (_ctx.preImage(3, item.id))
                        }, null, 8, ["src", "onClick"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_van_tab, null, {
              title: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("span", null, "(" + _toDisplayString(_ctx.initInfo.video.length) + ")", 1)
                ])
              ]),
              default: _withCtx(() => [
                (_ctx.initInfo.video.length != 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.initInfo.video, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.id,
                          class: "play-box"
                        }, [
                          _createVNode(_component_van_image, {
                            fit: "cover",
                            width: "6.375rem",
                            height: "6.375rem",
                            src: item.coverImg,
                            alt: "",
                            onClick: ($event: any) => (_ctx.showVideo(item.url))
                          }, null, 8, ["src", "onClick"]),
                          _createElementVNode("img", {
                            class: "play-video",
                            src: "https://qnui.xfarmer.com/xfarmer-ui/h5FarmerSpace/128%402x.png",
                            onClick: _withModifiers(($event: any) => (_ctx.showVideo(item.url)), ["stop"])
                          }, null, 8, _hoisted_14),
                          _createElementVNode("span", _hoisted_15, _toDisplayString(item.time), 1)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_van_tab, null, {
              title: _withCtx(() => [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("span", null, "(" + _toDisplayString(_ctx.initInfo.vrImg.length) + ")", 1)
                ])
              ]),
              default: _withCtx(() => [
                (_ctx.initInfo.vrImg.length != 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.initInfo.vrImg, (item) => {
                        return (_openBlock(), _createBlock(_component_van_image, {
                          key: item.id,
                          fit: "cover",
                          width: "9.625rem",
                          height: "4.8125rem",
                          src: item.url,
                          onClick: ($event: any) => (_ctx.toVrDetail(item.url))
                        }, null, 8, ["src", "onClick"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["active"]))
      : _createCommentVNode("", true),
    _createVNode(_component_van_image_preview),
    _createVNode(_component_preview_video, {
      visible: _ctx.showVideos,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.showVideos = $event)),
      url: _ctx.videoUrl,
      autoplay: ""
    }, null, 8, ["visible", "url"])
  ]))
}